import React, {useState, useContext, useEffect} from "react";
import {Link, useHistory, Redirect, useParams} from "react-router-dom"
import { UserContext } from "../../App";
import {authenticate, isAuthenticated} from "./helper"
import jwt from 'jsonwebtoken';
const ActivcateAccount = () => {
    const history = useHistory()
    const [password, setPassword] = useState("")
    const [error, setError] = useState(false)
   
    const [formData, setFormData] = useState({
        name: '',
        token: '',
        show: false
    });
    
      const {token} = useParams()
      useEffect(() => {
        let { name } = jwt.decode(token);
    
        if (token) {
          setFormData({ ...formData, name});
        }
    
        console.log(token, name);
      }, [token]);
      const { name, show } = formData;

    
    const PostData = (e) => {
        // e.preventDefault();
        
            fetch(`${process.env.REACT_APP_BACKEND}/emailactivate`, {
            method:"POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                token
            })
        })
        .then(res => res.json())
        .then(data => {
            if(data.error){
                setError(data.error);
            }
            else{
                setFormData({
                    ...formData,
                    show: true
                  });
                // return <Redirect to="/"/>
                
            }
        })
        .catch(err => console.log(err))
        
        

    }
    
    const errorMessege = () => (
        <div className="row">
            <div className="col s12 center-align">
                <div className="card-panel red white-text" style={{display: error ? "" : "none"}}>
                    {error}
                </div>
            </div>
        </div>
    )
    const success = () => (
        <div className="row">
                <div className="col s12 center-align">
                    <div className="card-panel green white-text" style={{display: show ? "" : "none"}}>
                        You are now verified please Login
                    </div>
                </div>
            </div>
    )
    

    return (
        <div className="row">
            <div className="col s12">
            <div className="mycard">
            

            <div className="card auth-card input-field">
            {errorMessege()}
            {success()}
                <h2>SocioRoorkee</h2>
                <h6>Welcome {name}</h6>
                <div className="row">
                    <div className="col s6 l6">
                        <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={() => {PostData()}}>
                            Activate Account
                        </button>
                    </div>
                    <div className="col s6 l6">
                    <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={() => {history.push("/login")}}>
                        Login Here
                    </button>
                    </div>
                </div>
                
                
                </div>
            
            </div>
            </div>
        </div>
        
    )
}

export default ActivcateAccount;